import React from 'react';

const Tooltip = ({ show, setShow, icon = 'info', children }) => {
  return (
    <span className="o-tooltip-booking o-tooltip-booking--inline u-ml-2">
      <a className="o-tooltip-booking__link" onClick={() => setShow(!show)}>
        {/* <svg className="o-tooltip-booking__click" role="presentation">
          <use xlinkHref={`${ASSET_DIR}/icons/icons.svg#sprite-${icon}`} />
          Click me
        </svg> */}
      </a>

      <div
        className={`o-tooltip-booking__content ${
          show ? 'o-tooltip-booking__content--visible' : ''
        }`}
      >
        {children}
      </div>
    </span>
  );
};

export default Tooltip;
